module.exports = "pegasus_template/assets/blocks/tile-element-line.png";